/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CompanyNoteType {
  Call = "call",
  ApolloAction = "apollo_action",
  UserAction = "user_action",
  ShipmentBooking = "shipment_booking",
  QuoteRun = "quote_run",
  CreditModified = "credit_modified",
  SystemEvent = "system_event",
  DialpadRecording = "dialpad_recording",
  InternalNote = "internal_note",
  SalesEmail = "sales_email",
  EmailLog = "email_log",
  Visit = "visit",
  AssignedSalesAgent = "assigned_sales_agent",
  AssignedCustomerSuccess = "assigned_customer_success",
  SalesPipelineStageChange = "sales_pipeline_stage_change",
  BookingEngagementChange = "booking_engagement_change",
  BookingEngagementOverrideSet = "booking_engagement_override_set",
  BookingEngagementOverrideCleared = "booking_engagement_override_cleared",
  SupportCall = "support_call",
  BannerMessage = "banner_message",
  CspAgreementCreated = "csp_agreement_created",
  CspAgreementUpdated = "csp_agreement_updated",
  CspAgreementActivated = "csp_agreement_activated",
  CspAgreementCancelled = "csp_agreement_cancelled",
  CspAgreementCarrierDeclined = "csp_agreement_carrier_declined",
  CspAgreementExistingCustomer = "csp_agreement_existing_customer",
  CspProposalSent = "csp_proposal_sent",
  CspAgreementFinalizing = "csp_agreement_finalizing",
  VideoCall = "video_call",
}

export function instanceOfCompanyNoteType(value: any): boolean {
  for (const key in CompanyNoteType) {
    if (Object.prototype.hasOwnProperty.call(CompanyNoteType, key)) {
      if (CompanyNoteType[key as keyof typeof CompanyNoteType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CompanyNoteTypeFromJSON(json: any): CompanyNoteType {
  return CompanyNoteTypeFromJSONTyped(json, false);
}

export function CompanyNoteTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyNoteType {
  return json as CompanyNoteType;
}

export function CompanyNoteTypeToJSON(value?: CompanyNoteType | null): any {
  return value as any;
}

export function CompanyNoteTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CompanyNoteType {
  return value as CompanyNoteType;
}
